import { Component } from '@angular/core';
import { isExperimental } from '@lockton-apps/shared/util/helpers';

@Component({
    selector: 'lui-navbar',
    templateUrl: './navbar.component.html',
    standalone: false
})
export class NavbarComponent {
  isExperimentalActive: boolean = isExperimental();
}
